/** @file Adds an editor-only reference image (drawn behind the skeleton, never exported). */
import { z } from 'zod';
import { prim } from '@pose2d/format/doc/schemaParts/primitives';
import { defineCommand } from '../defineCommand';
import { defineCreate } from '../_shared/defineCreate';

/** reference.add: the defineCreate factory under the spec name, with the documented display defaults. */
export const command = defineCommand({
  ...defineCreate({
    domain: 'reference',
    kind: 'reference',
    description: 'Add a reference image behind the skeleton (editor-only, never exported): image (name or id), x, y (0), scale (1), opacity 0..1 (0.5), visible (true), locked (false).',
    schema: z
      .object({
        id: z.string().exactOptional(),
        name: z.string().min(1),
        image: z.string().min(1),
        x: prim.finite.default(0),
        y: prim.finite.default(0),
        scale: prim.finite.positive().default(1),
        opacity: prim.unit.default(0.5),
        visible: z.boolean().default(true),
        locked: z.boolean().default(false),
      })
      .strict(),
    build: (input, ctx) => ({
      name: input.name, image: ctx.resolve('image', input.image), x: input.x, y: input.y,
      scale: input.scale, opacity: input.opacity, visible: input.visible, locked: input.locked,
    }),
  }),
  name: 'reference.add',
});
